export function shipmentPtlIndexValidate(shipment){
    var result = true;

    result = validateId(shipment.id);
    result = validateUniqueOrderNumber(shipment.unique_order_number);
    result = validateShipmentNumber(shipment.shipment_number);
    result = validateShippingService(shipment.shipping_service);
    result = validateCreatedAt(shipment.created_at);
    result = validateTotal(shipment.total);
    result = validateClientId(shipment.client_id);
    result = validateClient(shipment.client);
    result = validateLastStatus(shipment.last_status);
    return result;
}

function validateId(id) {    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateUniqueOrderNumber(unique_order_number) {
    if(typeof unique_order_number === 'string' && unique_order_number.trim() !== '') return true;
    else return false;
}

function validateShipmentNumber(shipment_number) {
    if(typeof shipment_number === 'string' && shipment_number.trim() !== '') return true;
    else return false;
}

function validateShippingService(shipping_service) {
    if(typeof shipping_service === 'string' && shipping_service.trim() !== '') return true;
    else return false;
}

function validateTotal(total) {
    if(/^([1-9]\d*|0)(\.\d+)?$/.test(total)) return true;
    else {
        return false;
    }
}

function validateCreatedAt(created_at) { 
    if(typeof created_at === 'string' && created_at.trim() !== '') return true;
    else return false;
}
function validateClientId(client_id) {
    if(Number.isInteger(client_id)) return true;
    else return false;
}

function validateClient(client) {
    if(client == null) return true;
    else {
        return typeof client === 'object' && 
        typeof client.id === "number" &&
        typeof client.name === "string" &&
        typeof client.rfid_by_product === "boolean" &&
        typeof client.client_type === "string" &&
        typeof client.guides_service === "boolean"
    }
}

function validateLastStatus(last_status) {
    if(typeof last_status === 'string' && last_status.trim() !== '') return true;
    else return false;
}